import { Injectable } from '@angular/core';
import { ProcessingStatus } from '../../shared/processing';
import { Observable } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ProcessingService {

  constructor(private processingStatus: ProcessingStatus) { }

  execute(valid: () => boolean, func: () => Observable<any>, success: (res: any) => void, error: (err: HttpErrorResponse) => void): void {
    this.processingStatus.setProcessingStatus(true);
    if (valid()) {
      func().subscribe(
        (res) => {
          success(res);
          this.processingStatus.setProcessingStatus(false);
        },
        (err: HttpErrorResponse) => {
          error(err);
          this.processingStatus.setProcessingStatus(false);
        }
      );
    } else {
      this.processingStatus.setProcessingStatus(false);
    }
  }
}
